// Flags a report type always needs, whatever is on the form or already saved: the job reads the period it covers from here.
const FIXED_FEATURE_FLAGS = {
    "ALL_DEVICES_30_DAY_REPORT": {report_window: 'rolling_30_days'}
};

const withFixedFeatureFlags = (reportType, featureFlags) => ({
    ...(featureFlags ?? {}),
    ...(FIXED_FEATURE_FLAGS[reportType] ?? {})
});

export { FIXED_FEATURE_FLAGS, withFixedFeatureFlags };
